import { createHashHistory, History } from 'history';

let history: History;

if (typeof window !== 'undefined') {
  history = createHashHistory();
}

export { history };
